<template>
  <div class="c-tags-nav">
    <div v-show="scrollBar" class="c-btn-con btn-left">
      <a href="javascript:;" @click="handleScroll(120)"><Icon :size="16" type="ios-arrow-back" /></a>
    </div>
    <div v-show="scrollBar" class="c-btn-con btn-right">
      <a href="javascript:;" @click="handleScroll(-120)"><Icon :size="16" type="ios-arrow-forward" /></a>
    </div>
    <div class="c-tag-box">
      <!-- scroll wrapper -->
      <div class="c-tag-scroll" ref="scrollOuter" @DOMMouseScroll="handlescroll" @mousewheel="handlescroll">
        <div class="c-tag-body" ref="scrollBody" :style="{ left: `${tagBodyLeft}px` }">
          <transition-group>
            <div
              class="c-nav"
              ref="tagsPageOpened"
              v-for="(item, index) of list"
              :key="`tag-nav-${index}`"
              :class="classes(item)"
              @click="handleClick(item)"
              @contextmenu.prevent="openMenu(item, $event)"
            >
              <div class="dot"></div>
              <span>{{ item.meta.title }}</span>

              <i class="el-icon-close close" @click.stop="handleClose(item)"></i>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <ul v-show="contextMenuVisible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu" ref="contextMenu">
      <li v-if="!isHome(currentContextMenuTag)" @click="closeTag(currentContextMenuTag)">关闭当前页签</li>
      <li v-if="!isHome(currentContextMenuTag)" @click="closeAllTags">清除全部页签</li>
    </ul>
  </div>
</template>
<script>
import beforeClose from '@/router/before-close'
import navMixin from '@/components/layout/nav-mixin'
import { isArray, timeout, throttle } from '@/common/js/utils'
import { getTagKey } from '@/common/js/tools'
export default {
  name: 'NavTags',
  mixins: [navMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    currentRouteObj() {
      // Just return the current route object which is passed as value
      return this.value
    },
    classes() {
      return (item) => {
        const currentKey = getTagKey(this.value)
        return {
          'c-nav-active': item.key === currentKey,
          'c-nav-close': isArray(this.list) && this.list.length > 1
        }
      }
    }
  },
  data() {
    return {
      scrollBar: null,
      tagBodyLeft: 0,
      contextMenuVisible: false,
      left: 0,
      top: 0,
      currentContextMenuTag: null
    }
  },
  watch: {
    list: {
      handler(nVal) {
        if (isArray(nVal) && nVal.length) {
          this.$nextTick(() => {
            this.handleResize()
          })
        }
      },
      deep: true
    },
    value(newVal) {
      this.$nextTick(() => {
        const key = getTagKey(newVal)
        this.getTagElementByKey(key)
      })
    }
  },
  methods: {
    isHome(route) {
      return route && (route.name === 'dashboardindex' || route.meta.title === '首页')
    },
    openMenu(item, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }
      this.top = e.clientY - 64 // header height

      this.contextMenuVisible = true
      this.currentContextMenuTag = item
    },
    closeMenu(e) {
      if (e && this.$refs.contextMenu && this.$refs.contextMenu.contains(e.target)) {
        return
      }
      this.contextMenuVisible = false
    },
    closeTag(route) {
      this.handleClose(route)
      this.contextMenuVisible = false
    },

    closeAllTags() {
      this.contextMenuVisible = false
      // Filter list to keep only home
      const homeTag = this.list.find((item) => this.isHome(item))
      // Update store to keep only home tag
      this.$store.commit('setTagNavList', homeTag ? [homeTag] : [])
      // Navigate to home
      if (homeTag) {
        this.turnToPage(homeTag)
      } else {
        this.$router.push({ name: 'dashboardindex' })
      }
    },
    handleClick(item) {
      if (item.fullPath === this.$route.fullPath) return
      this.turnToPage(item)
    },
    handleClose(current) {
      if (current.meta && current.meta.beforeCloseName && current.meta.beforeCloseName in beforeClose) {
        new Promise(beforeClose[current.meta.beforeCloseName]).then((close) => {
          if (close) {
            this.close(current)
          }
        })
      } else {
        this.close(current)
      }
    },
    close(route) {
      this.$emit('on-close', route)
    },
    handlescroll: throttle(function (e) {
      let delta = 0
      const type = e.type
      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = e.wheelDelta ? e.wheelDelta : -(e.detail || 0) * 40
      }
      this.handleScroll(delta)
    }, 16),
    handleScroll(offset) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth
      const spaceWidth = outerWidth - bodyWidth
      if (offset > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset)
      } else if (spaceWidth < 0 && spaceWidth <= this.tagBodyLeft) {
        this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, spaceWidth)
      }
    },
    getNameOrHref(item, children0) {
      return item.href ? `isTurnByHref_${item.href}` : children0 ? item.children[0].name : item.name
    },
    getTagElementByKey(key) {
      this.$nextTick(() => {
        this.refsTag = this.$refs.tagsPageOpened
        if (isArray(this.refsTag)) {
          // item passed to v-for is tag object, which has .key property
          // Wait, v-for="(item, index) of list"
          // We need to match item.key with key
          // But ref="tagsPageOpened" is an array of DOM elements or Vue Components?
          // Usually ref in v-for gives an array of Vue Instances or Elements.
          // Let's check template.
          // <div class="c-nav" ... >
          // It's a div. So refsTag is array of divs.
          // But div doesn't have .key property on itself unless we attach it.
          // Or we find index in list and use index to access refsTag[index].
          const index = this.list.findIndex((item) => item.key === key)
          if (index > -1 && this.refsTag[index]) {
            const tag = this.refsTag[index]
            this.moveToView(tag)
          }
        }
      })
    },
    // ... rest of methods

    // 滚动条自动定位
    moveToView(tag) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth
      if (tag.offsetLeft - this.tagBodyLeft < 0) this.tagBodyLeft = -tag.offsetLeft
      // 标签在可视区域左侧
      else if (tag.offsetLeft - this.tagBodyLeft > 0 && outerWidth - this.tagBodyLeft >= tag.offsetWidth + tag.offsetLeft) {
        this.tagBodyLeft = Math.min(0, outerWidth - tag.offsetLeft - tag.offsetWidth) // 标签在可视区域
      } else if (bodyWidth - outerWidth < 0) this.tagBodyLeft = 0
      else this.tagBodyLeft = outerWidth - tag.offsetLeft - tag.offsetWidth // 标签在可视区域右侧
    },
    getScrollBar() {
      let outerWidth = 0
      let bodyWidth = 0
      outerWidth = this.$refs.scrollOuter && this.$refs.scrollOuter.offsetWidth
      bodyWidth = this.$refs.scrollBody && this.$refs.scrollBody.offsetWidth
      return outerWidth && outerWidth && outerWidth < bodyWidth
    },
    handleResize() {
      timeout(60).then(() => {
        this.scrollBar = this.getScrollBar()
      })
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    document.addEventListener('click', this.closeMenu)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    document.removeEventListener('click', this.closeMenu)
  },
  destroyed() {}
}
</script>

<style lang="less" scoped>
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
    &:hover {
      background: #eee;
    }
  }
}
</style>
<style lang="scss" scoped>
.c-tags-nav {
  padding: 0 16px;
  position: relative;
  background: #f5f5f5;

  .c-btn-con {
    position: absolute;
    z-index: 7;
    height: 24px;
    line-height: 24px;
    background: #ffffff;
    margin-top: 8px;

    &.btn-left {
      left: 0;
    }

    &.btn-right {
      right: 0;
      border-right: solid 1px #efefef;
    }

    a {
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .c-tag-box {
    position: relative;
    z-index: 2;
    height: 50px;
    overflow: hidden;

    .c-tag-scroll {
      position: relative;
      width: 100%;
      height: inherit;
      display: block;

      .c-tag-body {
        display: inline-block;
        position: absolute;
        z-index: 90;
        overflow: visible;
        white-space: nowrap;
        transition: left 0.3s ease;
        text-align: left;
        padding-top: 8px;

        .c-nav {
          line-height: 32px;
          display: inline-block;
          padding: 0 14px 0 14px;
          border-radius: 4px;
          background-color: #fff;
          margin-left: 4px;
          cursor: pointer;

          &:first-child {
            margin-left: 0;
          }

          &.c-nav-close {
            .close {
              width: 16px;
              height: 16px;
              line-height: 16px;
              font-size: 12px;
              margin-left: 3px;
              text-align: center;
              border-radius: 50%;
              user-select: none;
              visibility: visible;

              &:hover {
                background-color: #c3c2c3;
              }
            }
          }

          &.c-nav-active {
            color: #fff;
            background-color: #1974ff !important;

            .close:hover {
              color: #fff;
            }

            .dot {
              background-color: #fff;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              display: inline-block;
              margin-right: 5px;
            }
          }

          .close {
            visibility: hidden;
          }
        }
      }
    }
  }
}
</style>
